import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import PublicIcon from '@material-ui/icons/Public';

export const rootRouteRef = createRouteRef();

const overviewPage = PageBlueprint.make({
  params: {
    path: '/spoke-overview',
    title: 'All Hubs & Spokes',
    icon: <PublicIcon fontSize="inherit" />,
    routeRef: rootRouteRef,
    loader: async () => {
      const { HubSpokeOverviewPage } = await import(
        './pages/HubSpokeOverviewPage'
      );
      return <HubSpokeOverviewPage />;
    },
  },
});

export const spokeOverviewPlugin = createFrontendPlugin({
  pluginId: 'spoke-overview',
  extensions: [overviewPage],
});
